import clsx from "clsx";

interface LinkAddDialogFooterProps {
  showBottomUI: boolean;
  onCancel: () => void;
  isEditMode: boolean;
  isValidValue: boolean;
}

const LinkAddDialogFooter = ({
  showBottomUI,
  onCancel,
  isEditMode,
  isValidValue,
}: LinkAddDialogFooterProps) => {
  const footerClasses = clsx(
    "flex w-full items-end justify-end gap-2.5 self-stretch overflow-hidden transition-all duration-200",
    showBottomUI && isValidValue
      ? "pointer-events-auto max-h-20 translate-y-0 p-2.5 opacity-100"
      : "pointer-events-none max-h-0 translate-y-2 opacity-0"
  );

  return (
    <div className={footerClasses}>
      <button
        type="button"
        className="flex h-9 w-[110px] items-center justify-center rounded-[5px] bg-w-4-hover-big text-[14px] text-body1 text-white transition hover:bg-w-8-hover"
        onMouseDown={(e) => {
          e.preventDefault(); // onBlur 방지
          onCancel();
        }}
      >
        Cancel
      </button>
      <button
        type="submit"
        className="flex h-9 w-[110px] items-center justify-center rounded-[5px] bg-w-16 text-[14px] text-body1 text-white transition hover:bg-w-24"
        onMouseDown={(e) => {
          e.preventDefault(); // onBlur 방지
        }}
      >
        {isEditMode ? "Save" : "Add"}
      </button>
    </div>
  );
};

export default LinkAddDialogFooter;
